const React = require("react");
const FieldC = require("../../../../dumb/Field/C");
const {DisplayDateDetailedMerchant} = require("../../../../dumb/DisplayData");
const {DisplayStatusWithdraw} = require("../../../../dumb/StatusDisplay");
const formatNumCoin = require("../../../../../utils/formatNumCoin");

module.exports = (props) => {
  const data = props.data || {};
  const status = data.lifeflow || '';
  const time = data.created_at || '';

  const list = [
    // {
    //   label: 'Withdrawal address',
    //   value: (
    //     <Tooltip>
    //       {data.address}
    //     </Tooltip>
    //   ),
    // },
    {
      label: 'Withdrawal amount',
      value: formatNumCoin(data.amount),
    },
    {
      label: 'Currency',
      value: data.cc_code,
    },
    {
      label: 'Status',
      value: (
        <DisplayStatusWithdraw status={status} />
      ),
    },
    {
      label: 'Transaction date and time',
      value: (
        <DisplayDateDetailedMerchant
          date={time}
        />
      ),
    }
  ]

  return (
    <div className="mt45 cfx mh-10 (lt|ph10|w1/3|w1/4@d2|w1/2@m|w@m2)>1">
      {list.map((el, id) => (
        <FieldC
          key={id}
          label={el.label}
          value={el.value || '-'}
        />
      ))}
    </div>
  )
}
